var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.showAlert &&
    _vm.whereIsRendered === _vm.alert.componentWhereIsRendered
    ? _c(
        "div",
        {
          class: [
            _vm.getType,
            "alert-container",
            {
              "render-at-the-bottom": _vm.renderAtTheBottom,
              "login-view": _vm.renderAtLoginView,
            },
          ],
        },
        [
          _c("span", { class: [_vm.getIcon, "alert-icon"] }),
          _c("div", { staticClass: "alert-text-container" }, [
            _c("span", {
              staticClass: "alert-text",
              domProps: { innerHTML: _vm._s(_vm.alert.message) },
            }),
            _c("span", {
              staticClass: "alert-subtext",
              domProps: { innerHTML: _vm._s(_vm.alert.subMessage) },
            }),
            _c("div", { staticClass: "alert-link-container" }, [
              _vm.alert.cancelLink
                ? _c(
                    "button",
                    {
                      staticClass: "alert-link",
                      attrs: { title: _vm.alert.cancelLink.tooltip },
                      on: { click: _vm.alert.cancelLink.callback },
                    },
                    [_vm._v(_vm._s(_vm.alert.cancelLink.text))]
                  )
                : _vm._e(),
              _vm.alert.acceptLink
                ? _c(
                    "button",
                    {
                      staticClass: "alert-link",
                      attrs: { title: _vm.alert.acceptLink.tooltip },
                      on: { click: _vm.alert.acceptLink.callback },
                    },
                    [_vm._v(_vm._s(_vm.alert.acceptLink.text))]
                  )
                : _vm._e(),
            ]),
          ]),
          _c("v-spacer"),
          _c("div", {
            staticClass: "lf-icon-close close-icon",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.closeAlertAction.apply(null, arguments)
              },
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }